import { Citation } from '@/models/Citations';
import { CitationPopover } from '@/components/reader/CitationPopover';

import { Fragment, FunctionComponent, useMemo } from 'react';

type Props = {
  citations?: Citation[];
  pageIndex: number;
  parentRef: React.RefObject<HTMLDivElement>;
};

/*
 * Example of rendering CitationPopovers
 */
export const InlineCitations: FunctionComponent<Props> = ({
  citations,
  pageIndex,
  parentRef,
}: Props) => {
  const citationsForPage = useMemo(() => {
    if (!citations) return false;
    return citations.filter(
      (citation) => citation.boundingBoxes[0].page === pageIndex,
    );
  }, [citations, pageIndex]);
  function renderCitations(): Array<React.ReactElement> {
    const citationPopovers: Array<React.ReactElement> = [];
    if (citationsForPage) {
      citationsForPage.forEach((citation, idx) => {
        citationPopovers.push(
          <CitationPopover
            key={`${citation.citedPaperId}_${idx}`}
            citation={citation}
            parentRef={parentRef}
          />,
        );
      });
    }
    return citationPopovers;
  }

  return <Fragment>{citationsForPage && renderCitations()}</Fragment>;
};
